import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const MidiOutput = ({output, midiEngine, syncedOutput, setSyncedOutput}) => { 
    let [tracked, setTracked] = useState(midiEngine.isOutputTracked(output));
    let synced = syncedOutput === output;

    const onClickSynced = useCallback(() => {
        if (!midiEngine.isOutputSynced(output)) {
            midiEngine.syncOutput(output);
            setSyncedOutput(output);
        } else {
            midiEngine.unsyncOutput(output);
            setSyncedOutput(undefined);
        }
        
    }, [setSyncedOutput]);

    const onClickTracked = useCallback((x) => {
        if (!midiEngine.isOutputTracked(output)) {
            midiEngine.trackOutput(output);
        } else {
            midiEngine.untrackOutput(output);
        }
        setTracked(!tracked);
    }, [setTracked, tracked]);

    return (
        <div className="midi-input">
          <div className="midi-name">{output.name}</div>
          <div className="midi-options">
              <div
                onClick={onClickTracked}
                className={tracked ? "midi-option enabled" : "midi-option"}>
                TRACK
              </div>
              <div
                onClick={onClickSynced}
                className={synced ? "midi-option enabled" : "midi-option"}>
                SYNC
              </div>
          </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MidiOutput);
